import { lazyLoad } from 'utils/loadable';

export const BlogCategoryListPage = lazyLoad(
  () => import('./index'),
  module => module.BlogCategoryListPage
);
